import { render, staticRenderFns } from "./BCardActionsContainer.vue?vue&type=template&id=820d266e&scoped=true"
import script from "./BCardActionsContainer.vue?vue&type=script&lang=js"
export * from "./BCardActionsContainer.vue?vue&type=script&lang=js"
import style0 from "./BCardActionsContainer.vue?vue&type=style&index=0&id=820d266e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820d266e",
  null
  
)

export default component.exports